<template>
    <div class="app-container">
        <div class="anjian-wrap">
            <div class="common-section-bg anjian-shaixuan">
                <div class="shaixuan-item">
                    <el-button type="primary"
                               icon="el-icon-refresh"
                               @click="handleCreate">
                   同步
                    </el-button>
                </div>
            </div>
            <div class="common-section-bg common-section-top biaoge-data">
                <el-table v-loading="listLoading"
                          :data="tableData"
                          style="width: 100%">
                    <el-table-column prop="id"
                                     label="id" />
                    <el-table-column prop="name"
                                     label="名称" />
                    <el-table-column prop="first_word"
                                     label="首字母" />
                    <el-table-column label="操作"
                                     align="center"
                                     width="300">
                        <template slot-scope="scope">
                            <el-button type="success"
                                       @click="showEdit(scope.row.id)">
                                修改
                            </el-button>
                        </template>
                    </el-table-column>

                </el-table>
                <!-- 分页 -->
            </div>
        </div>
        <el-drawer custom-class="custom-drawer"
                   :visible.sync="showDrawer"
                   :close-on-press-escape="false"
                   :wrapper-closable="false"
                   :show-close="false"
                   size="532px">
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">编辑</div>
                    <i class="el-icon-circle-close close-btn pointer"
                       @click="closeDrawerFun" />
                </div>
            </template>
            <div class="custom-content">
                <el-form
                        ref="ruleForm"
                        :model="danwei"
                        :rules="rules"
                        label-width="100px"
                >
                    <el-form-item label="首字母" prop="first_word">
                        <el-input v-model="danwei.first_word"/>
                    </el-form-item>
                </el-form>
                <div class="fix-fotter">
                    <el-button
                            style="min-width: 117px;background: #1067E0;font-size: 16px;border-color:#1067E0;"
                            size="mini"
                            type="primary"
                            @click="tijiao('ruleForm')"
                    >提交
                    </el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import { Loading } from "element-ui";
  import city from '@/api/tianzheng/city'

  export default {
    components: {
    },
    data () {
      return {
        pageLoading:'',
        tiLoding: false,//提价按钮加载状态
        showDrawer: false,
        listLoading: false,
        total: 5,
        danwei: {
          first_word: '',
        },
        rules: {
        },

        listQuery: {
          key: '',
          page: 1,
          size: 10
        },
        tableData: [

        ],
        CertTimer: '',
      }
    },
    created () {
      this.getList()
    },
    mounted () {
    },
    beforeDestroy () {
    },
    methods: {
      /**
       * @name: 获取列表
       * @return {*}
       * @desc:
       */
      getList (val) {
        if (val && val.page) {
          this.listQuery.page = val.page
        }
        this.listLoading = true
        city.list(this.listQuery).then(res => {
          this.listLoading = false
          if (res.code == 200) {
            this.tableData = res.result
          }
        })
      },
      /**
       * @name: 点击子项 0新增 1编辑
       * @param {*} type
       * @param {*} id
       * @return {*}
       * @desc:
       */
      handleCreate () {
        const that = this
        that.$confirm('确定同步城市信息吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            // 调用接口
            that.pageLoading = Loading.service({
              lock: true,   //是否锁定屏幕的滚动
              text: "加载中……",  //loading下面的文字
              background: "rgba(0, 0, 0, 0.7)",  //loading的背景色
              target:"body"      //loading显示在容器
          });
            city.sync({ }).then((res) => {
              that.pageLoading.close();
              that.pageLoading = null;
              if (res.code == 200) {
                that.$message.success(res.message)
                that.getList()
              } else {
                that.$message.error(res.message)
              }
            })
          })
          .catch(() => {
            that.pageLoading.close();
            that.pageLoading = null;
          })
      },
      showEdit (index) {
        const that = this
        this.showDrawer = true
        city.detail({
          id: index
        }).then(res => {
          if (res.code == 200) {
            this.danwei = res.result
          }
        })
      },
      /**
       * @name: 提交
       * @param {*} formName
       * @return {*}
       * @desc:
       */
      tijiao (formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.tiLoding = true;
            city.edit(this.danwei).then(res => {
              if (res.code === 200) {
                this.$message.success(res.message)
                this.closeDrawerFun()
                this.getList(this.listQuery.page)
              } else {
                this.tiLoding = false;
              }
            })
          } else {
            this.tiLoding = false;
            this.$message.warning(this.$t('form.verifyMsg'))
          }
        })
      },
      /**
       * @name: 关闭弹层
       * @return {*}
       * @desc:
       */
      closeDrawerFun () {
        this.showDrawer = false;
        this.tiLoding = false;
        this.getList()
      },

    }
  }
</script>
